import { PROJECT_DURATION_OPTIONS } from './constants.js';
import { dayjs } from '@contra/date';
const WEEK_IN_DAYS = 7;
const MONTH_IN_DAYS = 28;
export const convertJobDurationToDays = ({ amount, interval, }) => {
    switch (interval) {
        case 'DAY':
            return amount;
        case 'MONTH':
            return amount * 30;
        case 'WEEK':
            return amount * WEEK_IN_DAYS;
        default:
            return null;
    }
};
export const buildJobDurationDisplay = ({ amount, interval, noEndDate, }) => {
    if (!amount || !interval || noEndDate) {
        return 'Ongoing';
    }
    switch (interval) {
        case 'DAY': {
            const pluralizedInterval = amount === 1 ? 'day' : 'days';
            return `${amount} ${pluralizedInterval}`;
        }
        case 'MONTH': {
            const pluralizedInterval = amount === 1 ? 'month' : 'months';
            return `${amount} ${pluralizedInterval}`;
        }
        case 'WEEK': {
            const pluralizedInterval = amount === 1 ? 'week' : 'weeks';
            return `${amount} ${pluralizedInterval}`;
        }
        default:
            return 'Ongoing';
    }
};
export const convertJobDurationToLegacyDuration = (duration) => {
    if (!duration) {
        return null;
    }
    const { amount, interval } = duration;
    if (amount === 1 && interval === 'MONTH') {
        return PROJECT_DURATION_OPTIONS.find(({ id }) => id === 'WEEK');
    }
    if (amount === 3 && interval === 'MONTH') {
        return PROJECT_DURATION_OPTIONS.find(({ id }) => id === 'MONTH');
    }
    if (amount === 6 && interval === 'MONTH') {
        return PROJECT_DURATION_OPTIONS.find(({ id }) => id === 'MONTH');
    }
    if (amount === 1 && interval === 'WEEK') {
        return PROJECT_DURATION_OPTIONS.find(({ id }) => id === 'SHORT');
    }
    if (amount === 13 && interval === 'MONTH') {
        return PROJECT_DURATION_OPTIONS.find(({ id }) => id === 'LONG');
    }
    return null;
};
export const convertLegacyDurationToJobDuration = ({ duration, }) => {
    if (!duration) {
        return null;
    }
    if (duration < WEEK_IN_DAYS) {
        const pluralizedDay = duration === 1 ? 'day' : 'days';
        return {
            amount: duration,
            interval: 'DAY',
            pluralizedInterval: pluralizedDay,
        };
    }
    if (duration < MONTH_IN_DAYS) {
        const adjustedWeekDuration = Math.round(duration / WEEK_IN_DAYS);
        const pluralizedWeek = adjustedWeekDuration === 1 ? 'week' : 'weeks';
        return {
            amount: adjustedWeekDuration,
            interval: 'WEEK',
            pluralizedInterval: pluralizedWeek,
        };
    }
    const adjustedMonthDuration = Math.round(duration / MONTH_IN_DAYS);
    const pluralizedMonth = adjustedMonthDuration === 1 ? 'month' : 'months';
    return {
        amount: adjustedMonthDuration,
        interval: 'MONTH',
        pluralizedInterval: pluralizedMonth,
    };
};
export const getMaybeOpportunityDuration = ({ maxDuration, minDuration, }) => {
    if (!maxDuration || !minDuration) {
        return null;
    }
    const medianDuration = (maxDuration + minDuration) / 2;
    const durationOption = PROJECT_DURATION_OPTIONS.find((option) => {
        return (option.min &&
            option.max &&
            option.min <= medianDuration &&
            medianDuration <= option.max);
    }) ?? null;
    return durationOption;
};
export const getDurationRangeFromDateRange = ({ endsAt, startsAt, }) => {
    if (!endsAt) {
        return null;
    }
    const startsAtDate = dayjs(startsAt);
    const endsAtDate = dayjs(endsAt);
    const duration = endsAtDate.diff(startsAtDate, 'day');
    const durationOption = getMaybeOpportunityDuration({
        maxDuration: duration,
        minDuration: duration,
    });
    if (durationOption?.max && durationOption?.min) {
        return {
            max: durationOption.max,
            min: durationOption.min,
        };
    }
    return null;
};
//# sourceMappingURL=duration.js.map